// 站内说明、FAQ、关于我们、热榜数据

export const weeklyPicks = [
  {
    id: "wp-1",
    rank: 1,
    title: "「假唱风波」一周回看：技术鉴定进场，粉丝仍在等一份完整版",
    views: "92.4万阅读",
    trend: "up",
  },
  {
    id: "wp-2",
    rank: 2,
    title: "从“实锤”到“证伪”：一张AI聊天记录如何两度登上热搜",
    views: "67.1万阅读",
    trend: "up",
  },
  {
    id: "wp-3",
    rank: 3,
    title: "带货“翻车”后的72小时，主播、品牌、平台各自做了什么",
    views: "58.8万阅读",
    trend: "steady",
  },
  {
    id: "wp-4",
    rank: 4,
    title: "“被离婚”到晒全家福：吃瓜群众最需要的其实是等一等",
    views: "44.3万阅读",
    trend: "down",
  },
  {
    id: "wp-5",
    rank: 5,
    title: "争议判罚该不该复盘？裁判协会的回应把热度顶到了新高",
    views: "35.9万阅读",
    trend: "up",
  },
];

export const statsList = [
  { value: "1,200+", label: "累计追踪事件" },
  { value: "360+", label: "完成反转还原" },
  { value: "48h", label: "平均核验响应" },
  { value: "300万+", label: "每月追更读者" },
];

export const aboutBlocks = [
  {
    icon: "ri-focus-3-line",
    title: "我们在追踪什么",
    text: "吃瓜前线不是搬运工，而是一个带着时间线意识的吃瓜复盘站。我们聚焦那些仍在发酵、仍有可能反转、需要持续跟进的公共热点与娱乐事件。",
  },
  {
    icon: "ri-questionnaire-line",
    title: "为什么需要等一等",
    text: "很多“大瓜”的真相，往往藏在之后的三天里。我们坚持等齐多方回应、核对原始素材，再给出阶段性结论，并持续打上“待核实”与“已更新”标记。",
  },
  {
    icon: "ri-shield-check-line",
    title: "我们的内容原则",
    text: "先核后发、标注不确定、进展必回访。凡是无法当场证实的线索，我们一律标注来源状态；一旦出现反转，第一时间重写时间线，而不是删帖了事。",
  },
];

export const principles = [
  "先核后发：所有线索需至少两个独立信源或一份原始素材支撑",
  "标注不确定：暂无法证实的部分明确标注“待核实”，不与结论混淆",
  "进展必回访：已报道事件若出现新回应，一律在48小时内跟进更新",
  "反转即重写：证据反转后第一时间重建完整时间线，而非悄悄删除",
  "来源留痕：关键截图、链接与时间点统一留档，便于读者回溯",
  "拒绝造谣式传播：标题与正文口径一致，不做诱导点击的夸大表述",
];

export const testimonials = [
  {
    name: "阿茶 / 追更三年的读者",
    text: "最打动我的是它会在旧瓜下面回访更新。有些反转真是过了一个月才来，它居然还记得回来补一句。",
    stars: 5,
  },
  {
    name: "老K / 吃瓜群管理员",
    text: "以前群里传的截图动不动就反转，后来只信吃瓜前线的时间线，至少每条都标了来源和进度。",
    stars: 5,
  },
  {
    name: "小鹿 / 媒体从业者",
    text: "做选题时拿来当“事件脉络参考”很顺手，时间线排布清楚，帮我省了不少回溯的功夫。",
    stars: 4,
  },
];

export const faqs = [
  {
    q: "吃瓜前线和普通营销号有什么不同？",
    a: "核心区别在“追踪”二字。营销号通常只发情绪与结论，而我们为每一起热点建立带时间线的事件档案，持续回访后续进展、多方回应与反转更新，并对无法证实的线索明确标注“待核实”。",
  },
  {
    q: "热点事件多久更新一次进展？",
    a: "只要事件出现新的官方回应、权威声明或实锤证据，我们通常会在48小时内完成核验并更新对应的时间线与进度条；持续发酵的大事件则以小时为单位跟进。",
  },
  {
    q: "我发现一个线索或想要投稿，该怎么联系你们？",
    a: "可以通过页面底部的投稿邮箱与我们取得联系。请尽量附上原始截图、链接与时间点，团队会先做真实性核验，再决定是否纳入追踪，不会直接照单发布。",
  },
  {
    q: "如果爆料后来被证伪了，你们会怎么处理？",
    a: "一旦证据反转，我们会立刻在对应事件页顶部添加“反转更新”提示，并重建完整时间线说明反转原因，保留此前所有记录供读者回溯，而不是悄悄删除。",
  },
  {
    q: "如何判断一条信息是可信的？",
    a: "建议把握三个参考：一看是否有原始素材（完整视频、合同、官方文件）；二看涉事主体是否已回应；三看时间线是否对得上。我们的内容都会尽量给出这三点依据。",
  },
];

export const contactInfo = {
  slogan: "站得再近一点，看得再远一些。",
  email: "feedback@example.com",
  note: "仅用于事件线索投稿与读者反馈，会在核实后尽快回复。",
};